"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var Text_1 = __importDefault(require("shared/components/Text"));
var UnsupportedIntegration = function (_a) {
    var provider = _a.provider, handleGoBack = _a.handleGoBack;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, fontWeight: 600, mb: 1 }, { children: [provider, " intergration coming soon"] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, mb: 2 }, { children: ["We are working to add more integrations to Huded. If you're looking into connecting ", provider, ",", ' ', "send us an email to product@hudled.com"] })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: handleGoBack, sx: { mt: 2, ml: -2 } }, { children: "Go back" }))] }));
};
exports.default = UnsupportedIntegration;
